module.exports = __webpack_public_path__ + "img/mercado-pago.b4072429.png";